import { useState } from 'react';

import {
  StyledCard,
  CardHeaderStyled,
} from 'pages/Orders/OrdersShow/OrdersShowCommonInfo/OrdersShowCommonInfo.styled';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useShowController } from 'react-admin';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Collapse } from 'shared/mui/Collapse/Collapse';
import { ExpandIconButton } from 'shared/mui/IconButtons';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { EmbeddedFunctionField } from 'shared/react-admin/Fields';
import { ExternalLinkField } from 'shared/react-admin/Fields/ExternalLinkField/ExternalLinkField';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { Order } from 'types/embedded/order';
import { OrderActionUrls } from 'types/embedded/orderActionUrls';

export const OrdersShowCommonInfoResources = (): JSX.Element => {
  const translate = useTypedTranslate();

  const { record: order } = useShowController<Order>();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <RecordContextProvider value={order}>
      <StyledCard>
        <CardHeaderStyled
          appendActions={
            <ExpandIconButton isExpanded={isExpanded} onClick={handleExpandClick} size="small" />
          }
          sx={{ paddingBottom: '16px' }}
          title={translate('app.orders.urls.resources')}
          titleSize="smallBold"
        />
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <CardContent sx={{ padding: '0 16px 16px !important' }}>
            <CardTable
              tableBodyProps={{ sx: { '& td': { width: '152px' } } }}
              tableProps={{ sx: { tableLayout: 'fixed' } }}
            >
              <TableRowWrapper label={translate('app.orders.urls.return')}>
                <EmbeddedFunctionField
                  render={(record: OrderActionUrls) => (
                    <RecordContextProvider value={record}>
                      <ExternalLinkField source="returnUrl" />
                    </RecordContextProvider>
                  )}
                  sourceField="orderActionUrls"
                />
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.orders.urls.pending')}>
                <EmbeddedFunctionField
                  render={(record: OrderActionUrls) => (
                    <RecordContextProvider value={record}>
                      <ExternalLinkField source="pendingUrl" />
                    </RecordContextProvider>
                  )}
                  sourceField="orderActionUrls"
                />
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.orders.urls.success')}>
                <EmbeddedFunctionField
                  render={(record: OrderActionUrls) => (
                    <RecordContextProvider value={record}>
                      <ExternalLinkField source="successUrl" />
                    </RecordContextProvider>
                  )}
                  sourceField="orderActionUrls"
                />
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.orders.urls.failure')}>
                <EmbeddedFunctionField
                  render={(record: OrderActionUrls) => (
                    <RecordContextProvider value={record}>
                      <ExternalLinkField source="failureUrl" />
                    </RecordContextProvider>
                  )}
                  sourceField="orderActionUrls"
                />
              </TableRowWrapper>
              <TableRowWrapper label={translate('app.orders.urls.notification')}>
                <ReferenceField
                  link={false}
                  reference="order_notification_urls"
                  source="orderNotificationUrl.@id"
                >
                  <ExternalLinkField source="notificationUrl" />
                </ReferenceField>
              </TableRowWrapper>
            </CardTable>
          </CardContent>
        </Collapse>
      </StyledCard>
    </RecordContextProvider>
  );
};
